export default __webpack_public_path__ + "static/media/icon_commerce_integration.e7a63af1.svg";